module.exports = __webpack_public_path__ + "img/apple-logo.e92f5645.svg";